<template>

    <section class="c-settings_password">
        <h3>Zmień hasło</h3>
        <p>Zmiany hasła możesz dokonać w portalu.</p>
<!--        <form @submit.prevent="validateForm('update-password-form')" data-vv-scope="update-password-form">-->
<!--            <form-row>-->
<!--                <form-input-->
<!--                    v-model="old_password"-->
<!--                    label="Aktualne hasło"-->
<!--                    type="password"-->
<!--                    ref="password"-->
<!--                    data-vv-as="aktualne hasło"-->
<!--                    v-validate="'required'">-->
<!--                </form-input>-->
<!--            </form-row>-->
<!--            <form-row>-->
<!--                <form-input-->
<!--                    v-model="new_password"-->
<!--                    label="Nowe hasło"-->
<!--                    type="password"-->
<!--                    ref="hasło"-->
<!--                    data-vv-as="nowe hasło"-->
<!--                    v-validate="'required|min:6'">-->
<!--                </form-input>-->
<!--                <form-input-->
<!--                    v-model="new_password_confirmation"-->
<!--                    label="Powtórz hasło"-->
<!--                    type="password"-->
<!--                    data-vv-as="nowe hasło"-->
<!--                    v-validate="'required|confirmed:hasło'">-->
<!--                </form-input>-->
<!--            </form-row>-->
<!--            <form-row align="right">-->
<!--                <v-btn-->
<!--                    type="green"-->
<!--                    role="submit"-->
<!--                    has-loader-->
<!--                    :loading="isLoading">-->
<!--                    Zapisz-->
<!--                </v-btn>-->
<!--            </form-row>-->
<!--        </form>-->
    </section>

</template>


<script>

import {FormRow, FormInput} from 'Components/Form'
import VBtn from 'Components/VBtn'

export default {

    name: 'SettingsPassword',

    data() {
        return {
            old_password: '',
            new_password: '',
            new_password_confirmation: '',
            isLoading: false
        }
    },

    methods: {
        validateForm(scope) {
            this.isLoading = true
            this.$validator.validateAll(scope).then((isValid) => {
                if (isValid) {
                    this.updatePassword()
                } else {
                    this.isLoading = false
                    this.$alert.error('Zmień hasło', 'Popraw błędy w formularzu')
                }
            })
        },
        updatePassword() {
            this.$store.dispatch('PHT_PASSWORD_UPDATE', {
                old_password: this.old_password,
                new_password: this.new_password,
                new_password_confirmation: this.new_password_confirmation
            }).then((result) => {
                this.isLoading = false
                this.$alert.success('Zmień hasło', 'Hasło zostało zaktualizowane')
                this.old_password = ''
                this.new_password = ''
                this.new_password_confirmation = ''
                this.$validator.reset()

            }).catch((error) => {
                this.isLoading = false
                this.old_password = ''
                this.new_password = ''
                this.new_password_confirmation = ''
                this.$validator.reset()
                this.$alert.error('Zmień hasło', error.response.data.message)
            })
        }
    },

    components: {
        FormRow,
        FormInput,
        VBtn
    }

}

</script>


<style lang="scss">

@import '~Style/_utils.scss';

.c-settings_password {

}

</style>
